"use client";

import { Toaster as HotToaster } from "react-hot-toast";
import { cn } from "@/lib/utils";

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        className: cn(
          "!rounded-xl !border !border-border !bg-surface !px-4 !py-3 !text-body-sm !shadow-lg",
          "!text-foreground"
        ),
        success: {
          iconTheme: { primary: "var(--success)", secondary: "var(--foreground)" },
        },
        error: {
          iconTheme: { primary: "var(--error)", secondary: "var(--foreground)" },
        },
      }}
    />
  );
}
